import React, { Component } from 'react';
import {http} from '../misc/http';
import {Link} from 'react-router-dom';
import {isEmail} from 'validator';
import Layout from '../layout/Auth';
import profile from '../assets/profile.png';
import sun from '../assets/sun.png';
import showIcon from '../assets/showPassword.svg';
import hideIcon from '../assets/hidePassword.svg';

export default class Login extends Component {
  state={
    formUser: {
      email: '',
      password: '',
      type: 'user'
    },
    disabled: true,
    showPassword: false
  }
  
  handleLogin = async () => {
    let params = {
      method:'POST',
      path:'auth/login',
      data:this.state.formUser
    }
    let {data} = await http(params);
    if (data.status === true && data.code === 200) {
      localStorage.setItem('kominfo-psre', JSON.stringify(data.data));
      this.resetForm();
      this.props.history.push('/')
    }
  }

  validate = () => {
    let {formUser:{email, password}, disabled} = this.state;
    if (isEmail(email) && password.match(/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[#$^+=!*()@%&]).{8,}$/g) !== null) disabled = false
    else disabled = true;
    this.setState({disabled})
  }
  
  handleOnChange = async ({target: {name, value}}) => {
    let {formUser} = this.state;
    formUser[name] = value;
    await this.setState({formUser});
    this.validate()
  }

  resetForm = () => {
    let {formUser} = this.state;
    formUser.email = '';
    formUser.password = '';
    this.setState({formUser})
  }

  handleKeyPress = ({keyCode}) => {
    if (keyCode === 13) this.handleLogin()
  }

  handleShowPassword = () => {
    this.setState({showPassword: this.state.showPassword ? false : true})
  }

  render() {
    return (
      <Layout>
        <div className="card card-primary card-auth" style={{borderRadius: '0px'}}>
          <div className="card-body text-center">
            <p className="mb-4" style={{fontSize: '25px', fontWeight: '600'}}>Selamat Datang!</p><br/>
            <div className="auth" action="">
              <div className="input-group mb-3">
                <div className="input-group-prepend"><span className="input-group-text" id="basic-addon1"><img src={profile} alt="profile" style={{width: '20px',height: '20px'}} /></span></div>
                <input className="form-control" type="email" placeholder="Alamat Email Anda" name="email" onChange={(e) => this.handleOnChange(e)} />
              </div>
              <div className="input-group mb-3">
                <div className="input-group-prepend"><span className="input-group-text" id="basic-addon1"><img src={sun} alt="sun" style={{width: '20px',height: '20px'}} /></span></div>
                <input className="form-control" type={this.state.showPassword ? 'text': 'password'} placeholder="Password" name="password" onChange={(e) => this.handleOnChange(e)} onKeyDown={this.handleKeyPress}/>
                <div style={{
                  height: '20px',
                  width: '36px'
                }} onClick={() => this.handleShowPassword()}>
                  <img style={{marginTop: '10px'}} src={this.state.showPassword ? hideIcon : showIcon} alt='showHide'/>
                </div>
              </div>
              <label style={{fontSize: '13px'}}>Lupa password? <Link to='/forgotPassword' style={{color: '#005097'}}>Klik Disini</Link></label>
              <button className="btn btn-blue w-100 mt-4" style={{padding: '14px 25px !important', background: '#005097'}}     disabled={this.state.disabled} onClick={() => this.handleLogin()}>Masuk Sekarang</button>
              <p className="mt-5" style={{fontSize: '13px'}}>Belum memiliki akun? <Link to='/signup' style={{color: '#005097'}}>Daftar Disini</Link></p>
            </div>
          </div>
        </div>
      </Layout>
    )
  }
}
